import type { z } from 'zod'
import { projectDataApi } from './projectDataApi'
import { SummarizersResponseSchema, SummaryHistorySchema, SummarizerMutationSchema, type SummarizerRequestSchema } from '../schemas/sessionSummarizers'

const api = projectDataApi.injectEndpoints({
  endpoints: builder => ({
    getSessionSummarizers: builder.query<z.infer<typeof SummarizersResponseSchema>, string>({
      query: projectId => ({ url: '/api/project-session-summarizers', params: { project_id: projectId } }),
      transformResponse: (response: unknown) => SummarizersResponseSchema.parse(response),
      providesTags: (_result, _error, projectId) => [{ type: 'ProjectUserSessions', id: projectId }],
    }),
    getSessionSummary: builder.query<z.infer<typeof SummaryHistorySchema>, { projectId: string; id: string; day?: string }>({
      query: ({ projectId, id, day }) => ({ url: '/api/project-session-summarizers', params: { project_id: projectId, id, day } }),
      transformResponse: (response: unknown) => SummaryHistorySchema.parse(response),
      providesTags: (_result, _error, args) => [{ type: 'ProjectUserSessions', id: args.projectId }],
    }),
    updateSessionSummarizer: builder.mutation<z.infer<typeof SummarizerMutationSchema>, { projectId: string; body: z.infer<typeof SummarizerRequestSchema> }>({
      query: ({ projectId, body }) => ({ url: '/api/project-session-summarizers', params: { project_id: projectId }, method: 'POST', body }),
      transformResponse: (response: unknown) => SummarizerMutationSchema.parse(response),
      invalidatesTags: (_result, _error, args) => [{ type: 'ProjectUserSessions', id: args.projectId }],
    }),
  }),
})
export const { useGetSessionSummarizersQuery, useGetSessionSummaryQuery, useUpdateSessionSummarizerMutation } = api
